import { useEffect, useState } from 'react'
import getScrollBarWidth from 'common/helpers/getters/getScrollBarWidth'


const useScrollBarWidth = (): number => {
  const [ value, setValue ] = useState(0)

  useEffect(() => {
    setValue(getScrollBarWidth)
  }, [])

  return value
}


export default useScrollBarWidth
